import SocialMediaButton from "../SocialMediaButton";
import { useGoogleLogin } from "@react-oauth/google";
import GoogleIcon from "../../../../assets/icons/user-menu-icons/google-icon.svg";
import { oAuthLogin, setSocialMediaToken, showToast, useAppDispatch, useAppSelector } from "@hypexone/uicore";
import { useEffect, useState } from "react";
import { OAuthLoginRequestBody, SocialMediaTypeEnum } from "../../../../utils/types/userMenu.types";
import { isMobile } from "react-device-detect";

const GoogleOAuth = () => {
  const dispatch = useAppDispatch();
  const [response, setResponse] = useState<any>(null);
  const { socialMediaType } = useAppSelector((state) => state.auth);
  const { langData } = useAppSelector((state) => state.cms);
  const ErrorToast = (message: string) => {
    dispatch(
      showToast({
        type: 'error',
        message,
      })
    );
  };
  const handleLogin = async (token: string) => {
    const reqBody: OAuthLoginRequestBody = {
      accessToken: token,
      loginOauthType: socialMediaType,
      loginRequestType: "OAUTH_FACTOR_SIGN_IN",
      code: "",
    };

    dispatch(setSocialMediaToken(token));
    const resp = await dispatch(oAuthLogin(reqBody));
    localStorage.setItem("responseEmail", JSON.stringify(resp.payload));

    // ErrorToast(resp.payload.toString());
    setResponse(resp);
  };

  const googleLogin = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      handleLogin(tokenResponse.access_token);
    },
    onError: () => {
    },
    scope: langData?.["emailProfile"],
  });

  return (
    <SocialMediaButton
      handleButtonClick={() => googleLogin()}
      iconSrc={GoogleIcon}
      buttonLabel={isMobile ? SocialMediaTypeEnum.GOOGLE : null}
    />
  );
};

export default GoogleOAuth;
